<template>
  <div class="copyright">
    <!-- <template v-repeat="copy_list">
      &copy;{{$value}}／
    </template> -->
    <!-- <template v-for="copy in copy_list">
      &copy;{{copy}}／
    </template> -->
    <template v-for="copy in copy_list">
      <span v-html="copy"></span>
    </template>
  </div>
</template>

<script>
export default {
  name: 'CopyRight',
  data () {
    return {
      copy_list: [
        // onepiece
        '&copy;尾田栄一郎／集英社・フジテレビ・東映アニメーション　',

        // naruto
        '&copy;岸本斉史 スコット／集英社・テレビ東京・ぴえろ　',

        // yugioh
        '&copy;スタジオ・ダイス/集英社・テレビ東京・KONAMI　',

        // bleach
        '&copy;久保帯人／集英社・テレビ東京・dentsu・ぴえろ　',

        // spyfamily
        '&copy;遠藤達哉／集英社・SPY×FAMILY製作委員会　',//2021.12.18

        // haikyu
        '&copy;古舘春一／集英社・「ハイキュー!!」製作委員会・MBS　',//2021.12.18

        // kimetsu
        '&copy;吾峠呼世晴／集英社・アニプレックス・ufotable　',

        // jujutsu
        '&copy;芥見下々／集英社・呪術廻戦製作委員会　',

        // digimon
        '&copy;本郷あきよし・東映アニメーション　',

      ]
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/CopyRight.vue